import React, { useState, useEffect } from "react";
import "./Contato.scss";
import { desktopImages } from "../../images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2.3, // Mostrar 2 logos e um pedaço da terceira
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: "unslick", // Desativar carrossel em telas maiores
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1,
        margin: 0,
        variableWidth: true,
      },
    },
  ],
};
const ENABLE_POPUP = false;

const Contato = () => {
  const [showPopup, setShowPopup] = useState(
    () => ENABLE_POPUP && localStorage.getItem("popupactive-feriado") === null,
  );

  useEffect(() => {
    if (showPopup) {
      document.documentElement.classList.add("popoverflow-hide");
    } else {
      document.documentElement.classList.remove("popoverflow-hide");
    }
    return () => document.documentElement.classList.remove("popoverflow-hide");
  }, [showPopup]);

  const handleClosePopup = (e) => {
    e.preventDefault();
    localStorage.setItem("popupactive-feriado", "true");
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="modalHorario-1" onClick={handleClosePopup}>
          <div id="popup-horario-1" onClick={(e) => e.stopPropagation()}>
            <a href="#" className="bt-fechar" onClick={handleClosePopup}>
              <img
                className="iconeCross"
                src="https://essentia.com.br/wp-content/uploads/2021/02/closeIcon.png"
                alt="Fechar"
                width="41"
              />
            </a>
            <div className="content-popup">
              <p className="textModal" style={{ letterSpacing: "2px" }}>
                FERIADO
              </p>

              <p className="textModal-2">
                No dia 02/11, estaremos em recesso.
                <br />
                Retornaremos no dia 03/11, no nosso horário normal.
              </p>
            </div>
          </div>
        </div>
      )}
      <div id="contato">
        <div class="body-main">
          <div class="logo-group">
            <div class="img-test-bg"></div>
          </div>
          <h1 class="titulo-inicio">
            Entre em contato para conhecer as empresas do <b>Essentia Group</b>,
            tirar as suas dúvidas e fazer os seus pedidos.
          </h1>
          <div className="container">
            <div className="englobe">
              <div className="logo-img-pharma">
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-pharma.png"
                  alt=""
                />
                <p className="logo-email">
                  <a
                    href="https://essentia.com.br/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    essentia.com.br
                  </a>
                </p>
                <p className="logo-email-zero-space">
                  {" "}
                  <a
                    href="https://www.instagram.com/essentiapharma/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @essentiapharma
                  </a>
                </p>
              </div>
              <div class="container-1">
                <div class="box-grupo pharma">
                  <div class="intro">
                    <h2 class="titulo">
                      Central de <br className="mobile" /> atendimento ao
                      cliente
                    </h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=554837717121"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 3771.7121
                        </a>
                      </div>
                      <div className="numero-2">
                        <svg
                          id="Phone_Icon"
                          data-name="Phone Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.583"
                          height="18.75"
                          viewBox="0 0 24 24"
                        >
                          <path
                            id="phone-path"
                            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.08 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72c.14 1.21.47 2.38.99 3.47a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l.7-.7a2 2 0 0 1 2.11-.45c1.09.52 2.26.85 3.47.99a2 2 0 0 1 1.72 2z"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </svg>
                        <p className="telefone">0800 724 9099</p>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:meupedido@essentia.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      meupedido@essentia.com.br
                    </a>

                    <div className="border"></div>
                  </div>
                </div>
                <div class="box-grupo injetaveis">
                  <div class="intro">
                    <h2 class="titulo">ATENDIMENTO INJETÁVEIS</h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=554888029876"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 9 8802.9876
                        </a>
                      </div>
                      <div className="numero-2"></div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:injetaveis@essentia.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      injetaveis@essentia.com.br
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="englobe-min">
              <div className="logo-img-nutrition">
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-nutrition.png"
                  alt=""
                />
                <p className="logo-email">
                  <a
                    href="https://essentialnutrition.com.br/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    essentialnutrition.com.br
                  </a>
                </p>
                <p className="logo-email-zero-space">
                  {" "}
                  <a
                    href="https://www.instagram.com/essential_nutrition/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @essential_nutrition
                  </a>
                </p>
              </div>
              <div class="container-1">
                <div class="box-grupo pharma">
                  <div class="intro">
                    <h2 class="titulo">ATENDIMENTO</h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=5548988076983"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98807-6983
                        </a>
                      </div>
                      <div className="numero-2">
                        <svg
                          id="Phone_Icon"
                          data-name="Phone Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 24 24"
                        >
                          <path
                            id="phone-path"
                            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.08 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72c.14 1.21.47 2.38.99 3.47a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l.7-.7a2 2 0 0 1 2.11-.45c1.09.52 2.26.85 3.47.99a2 2 0 0 1 1.72 2z"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </svg>
                        <p className="telefone">0800 607 9030</p>
                      </div>
                      <div className="numero-2">
                        <svg
                          id="Phone_Icon"
                          data-name="Phone Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.583"
                          height="18.75"
                          viewBox="0 0 24 24"
                        >
                          <path
                            id="phone-path"
                            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.08 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72c.14 1.21.47 2.38.99 3.47a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l.7-.7a2 2 0 0 1 2.11-.45c1.09.52 2.26.85 3.47.99a2 2 0 0 1 1.72 2z"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </svg>
                        <p className="telefone">
                          4007-2310 <i>(Capitais)</i>
                        </p>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:contato@essentialnutrition.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      contato@essentialnutrition.com.br
                    </a>
                    <p target="_blank" href="" class="cep"></p>
                    <div className="border"></div>
                  </div>
                </div>
                <div class="box-grupo injetaveis">
                  <div class="intro">
                    <h2 class="titulo">
                      SEJA UM REVENDEDOR
                      <br className="mobile" /> CREDENCIADO
                    </h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=5548988347981"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98834-7981
                        </a>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:revendas@essentialnutrition.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      revendas@essentialnutrition.com.br
                    </a>
                    <a
                      target="_blank"
                      href=" https://hub.essentialnutrition.com.br/customer/account/login/"
                      class="mail"
                      rel="noreferrer"
                    >
                      hub.essentialnutrition.com.br
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="englobe-min1">
              <div className="logo-img-noorskin">
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-noorskin.png"
                  alt=""
                />
                <p className="logo-email">
                  <a
                    href="https://noorskin.com.br/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    noorskin.com.br
                  </a>
                </p>
                <p className="logo-email-zero-space">
                  {" "}
                  <a
                    href="https://www.instagram.com/noorskinbeauty/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @noorskinbeauty
                  </a>
                </p>
              </div>
              <div class="container-1">
                <div class="box-grupo pharma">
                  <div class="intro">
                    <h2 class="titulo">ATENDIMENTO</h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=5548988583701"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98858-3701
                        </a>
                      </div>
                      <div className="numero-2">
                        <svg
                          id="Phone_Icon"
                          data-name="Phone Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.583"
                          height="18.75"
                          viewBox="0 0 24 24"
                        >
                          <path
                            id="phone-path"
                            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.08 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72c.14 1.21.47 2.38.99 3.47a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l.7-.7a2 2 0 0 1 2.11-.45c1.09.52 2.26.85 3.47.99a2 2 0 0 1 1.72 2z"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </svg>
                        <p className="telefone">0800 777 9100</p>
                      </div>
                      <div className="numero-2">
                        <svg
                          id="Phone_Icon"
                          data-name="Phone Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.583"
                          height="18.75"
                          viewBox="0 0 24 24"
                        >
                          <path
                            id="phone-path"
                            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.08 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72c.14 1.21.47 2.38.99 3.47a2 2 0 0 1-.45 2.11L9 10a16 16 0 0 0 5 5l.7-.7a2 2 0 0 1 2.11-.45c1.09.52 2.26.85 3.47.99a2 2 0 0 1 1.72 2z"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </svg>
                        <p className="telefone">
                          4007-1371 <i>(Capitais)</i>
                        </p>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:contato@noorskin.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      contato@noorskin.com.br
                    </a>
                    <p target="_blank" href="" class="cep"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="englobe-min2">
              <div className="logo-img-tech">
                <img
                  className="space"
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-tecnologies.png"
                  alt=""
                />
              </div>
              <div class="container-1">
                <div class="box-grupo-out">
                  <div class="intro">
                    <h2 class="titulo">ATENDIMENTO</h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://wa.me/5548988120061?text=Gostaria%20de%20uma%20apresenta%C3%A7%C3%A3o%20do%20Easy%20Health "
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98812-0061
                        </a>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:contato@essentia.tech"
                      class="mail"
                      rel="noreferrer"
                    >
                      contato@essentia.tech
                    </a>
                    <p target="_blank" href="" class="cep"></p>
                  </div>
                </div>
              </div>
              <div className="logo-img-easy">
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-easy-contato.png"
                  alt=""
                />
                <p className="logo-email">
                  <a
                    href="https://easy-health.app/landing-page/index.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    easy-health.app
                  </a>
                </p>
                <p className="logo-email-zero-space">
                  {" "}
                  <a
                    href="https://www.instagram.com//essentia_technologies/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @essentia_technologies
                  </a>
                </p>
              </div>
              <div class="container-1">
                <div class="box-grupo pharma">
                  <div class="intro">
                    <h2 class="titulo-easy">
                      FALE COM O<br className="mobile" /> NOSSO SUPORTE
                    </h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=5548988172234"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98817-2234
                        </a>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:suporte@easy-health.app"
                      class="mail"
                      rel="noreferrer"
                    >
                      suporte@easy-health.app
                    </a>
                    <p target="_blank" href="" class="cep"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="englobe-min1">
            <div className="logo-img-exp">
              <img
                src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-experiencia.png"
                alt=""
              />
              <p className="logo-email">
                <a
                  href="https://essentiagroup.com.br/essentiaexperience"
                  target="_blank"
                  rel="noreferrer"
                >
                  essentiagroup.com.br/
                  <br />
                  essentiaexperience
                </a>
              </p>
              <p className="logo-email-zero-space1">
                {" "}
                <a
                  href="https://www.instagram.com/essentiagroup/"
                  target="_blank"
                  rel="noreferrer"
                >
                  @essentiagroup
                </a>
              </p>
            </div>
            <div class="container-1">
              <div class="box-grupo pharma">
                <div class="intro">
                  <h2 class="titulo">VISITE O ESSENTIA GROUP</h2>
                </div>
                <div class="contatos">
                  <div class="whats-div">
                    <div className="numero-1">
                      <svg
                        id="Whats_App"
                        data-name="Whats App"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="16.31"
                        height="16.35"
                        viewBox="0 0 18.583 18.75"
                      >
                        <defs>
                          <clipPath id="clip-path">
                            <rect
                              id="Retângulo_1055"
                              data-name="Retângulo 1055"
                              width="18.583"
                              height="18.75"
                              fill="none"
                              stroke="#242222"
                              stroke-width="0.4"
                            />
                          </clipPath>
                        </defs>
                        <g
                          id="Grupo_1448"
                          data-name="Grupo 1448"
                          clip-path="url(#clip-path)"
                        >
                          <path
                            id="Caminho_735"
                            data-name="Caminho 735"
                            d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                            transform="translate(0 0)"
                            fill="#f1f2f2"
                            stroke="#242222"
                            stroke-width="0.4"
                            fill-rule="evenodd"
                          />
                        </g>
                      </svg>
                      <a
                        target="_blank"
                        href="https://api.whatsapp.com/send?phone=5511988501800"
                        class="whats"
                        rel="noreferrer"
                      >
                        (11) 98850-1800
                      </a>
                    </div>
                  </div>
                  <a
                    target="_blank"
                    href="mailto:essentiaexperience@essentiagroup.com.br"
                    class="mail1"
                    rel="noreferrer"
                  >
                    essentiaexperience@essentiagroup.com.br
                  </a>
                  <p target="_blank" href="" class="cep">
                    Rua João Lourenço, 530
                    <br className="mobile" /> <span className="traco1">|</span>{" "}
                    Vila Nova Conceição - São Paulo
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="englobe-min1">
              <div className="logo-img-begenerous">
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/contatos/logo-essentia-begenerous.png"
                  alt=""
                />
                <p className="logo-email">
                  <a
                    href="https://begenerous.com.br/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    begenerous.com.br{" "}
                  </a>
                </p>
                <p className="logo-email-zero-space">
                  {" "}
                  <a
                    href="https://www.instagram.com/projetobegenerous/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @projetobegenerous
                  </a>
                </p>
              </div>
              <div class="container-1">
                <div class="box-grupo pharma">
                  <div class="intro">
                    <h2 class="titulo">
                      CONHEÇA NOSSO
                      <br className="mobile" /> PROJETO SOCIAL
                    </h2>
                  </div>
                  <div class="contatos">
                    <div class="whats-div">
                      <div className="numero-1">
                        <svg
                          id="Whats_App"
                          data-name="Whats App"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16.31"
                          height="16.35"
                          viewBox="0 0 18.583 18.75"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1055"
                                data-name="Retângulo 1055"
                                width="18.583"
                                height="18.75"
                                fill="none"
                                stroke="#242222"
                                stroke-width="0.4"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Grupo_1448"
                            data-name="Grupo 1448"
                            clip-path="url(#clip-path)"
                          >
                            <path
                              id="Caminho_735"
                              data-name="Caminho 735"
                              d="M13.737,11.209c-.228-.125-1.352-.732-1.562-.818s-.365-.13-.529.1-.63.735-.771.885-.278.165-.508.039a6.369,6.369,0,0,1-1.829-1.227A7.022,7.022,0,0,1,7.3,8.523c-.128-.238,0-.36.12-.472s.243-.264.365-.4a1.6,1.6,0,0,0,.247-.38.428.428,0,0,0,0-.409c-.054-.119-.476-1.284-.653-1.758S7,4.706,6.869,4.7s-.29-.03-.446-.036a.856.856,0,0,0-.632.268A2.614,2.614,0,0,0,4.9,6.847a4.535,4.535,0,0,0,.861,2.446,9.56,9.56,0,0,0,3.845,3.669c2.333,1.023,2.345.711,2.773.688A2.357,2.357,0,0,0,14,12.6a1.952,1.952,0,0,0,.177-1.1c-.055-.1-.208-.164-.436-.289M9.459,16.737A7.539,7.539,0,0,1,5.282,15.48l-2.919.936.949-2.824a7.589,7.589,0,1,1,6.147,3.146M9.459,0A9.137,9.137,0,0,0,1.647,13.85L0,18.75l5.05-1.619A9.131,9.131,0,1,0,9.459,0"
                              transform="translate(0 0)"
                              fill="#f1f2f2"
                              stroke="#242222"
                              stroke-width="0.4"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                        <a
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=5548988183492"
                          class="whats"
                          rel="noreferrer"
                        >
                          (48) 98818-3492
                        </a>
                      </div>
                    </div>
                    <a
                      target="_blank"
                      href="mailto:contato@begenerous.com.br"
                      class="mail"
                      rel="noreferrer"
                    >
                      contato@begenerous.com.br
                    </a>
                    <p target="_blank" href="" class="cep"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contato;
